import React from 'react';
import PropTypes from 'prop-types';

import Picture from '../../../Util/Picture/Picture';

class FlyoutTile extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      active: false,
    };

    this.toggleActive = this.toggleActive.bind(this);
    this.onChange = this.onChange.bind(this);
  }

  componentWillMount() {
    this.setState({
      ...this.props.subcategory,
    });
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      ...nextProps.subcategory,
      active: this.props.isActiveSubCategory({ ...nextProps.subcategory }),
    });
  }

  onChange() {
    this.setState({
      active: !this.state.active,
    });
  }

  toggleActive(e) {
    e.preventDefault();
    this.setState({
      active: !this.state.active,
    });
    this.props.toggleActiveSubCategory({ ...this.state });
  }

  render() {
    return (
      <div
        className="m-flyout__slide slick-slide"
        key={`${this.state.id}_wrapper`}
        onClick={this.toggleActive}
        role="button"
        tabIndex={-1}
      >
        <label htmlFor={this.state.id} key={`${this.state.id}_label`}>
          {(() => {
            if (this.state.image.hasOwnProperty('180') && this.state.image.hasOwnProperty('220')) {
              return (<Picture
                src={{
                  sm: this.state.image['180'],
                  md: this.state.image['180'],
                  lg: this.state.image['180'],
                  xl: this.state.image['220'],
                  xxl: this.state.image['220'],
                  xxxl: this.state.image['220'],
                  default: this.state.image['220'],
                }}
                alt={this.state.alt}
                key={`${this.state.id}_img`}
                draggable={false}
                disableLL
                disableZoom
              />);
            }
            return null;
          })()}

          <span className="m-flyout__categorytitle" key={`${this.state.id}_title`}>
            {this.state.title}
          </span>
          <div className="m-flyout__checkbox" key={`${this.state.id}_checkbox`}>
            <input type="checkbox" checked={this.state.active} onChange={this.onChange} id={this.state.id} />
            <span>
              <svg>
                <use xlinkHref="#Lenspire_Icon_Check" />
              </svg>
            </span>
          </div>
        </label>
      </div>
    );
  }
}

FlyoutTile.propTypes = {
  subcategory: PropTypes.shape({
    id: PropTypes.string,
    img: PropTypes.string,
    title: PropTypes.string,
  }),
  toggleActiveSubCategory: PropTypes.func,
  isActiveSubCategory: PropTypes.func,
};

FlyoutTile.defaultProps = {
  subcategory: {},
  toggleActiveSubCategory: () => {
  },
  isActiveSubCategory: () => {
  },
};

export default FlyoutTile;



// WEBPACK FOOTER //
// ./frontend/js/Components/Globals/Header/Flyout/FlyoutTile.jsx